import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import Requests from "../../pages/services/Requests";
import Header from "../header";
import SidebarNav from "../sidebar";

const Clients = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 15,
        total: 0,
    });

    const columns = [
        {
            title: "#",
            dataIndex: "id",
            sorter: (a, b) => a.id - b.id,
            render: (text) => <span>{text}</span>,
        },
        {
            title: "Client Name",
            dataIndex: "name",
            render: (text) => <span>{text}</span>,
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: "Phone",
            dataIndex: "phone",
            render: (text) => <span>{text}</span>,
            sorter: (a, b) => a.phone.localeCompare(b.phone),
        },
        {
            title: "Email",
            dataIndex: "email",
            render: (text) => <span>{text}</span>,
            sorter: (a, b) => a.email.localeCompare(b.email),
        },
        {
            title: "Total Appointments",
            dataIndex: "total_appointments",
            render: (text) => (
                <span className="badge badge-primary">{text}</span>
            ),
            sorter: (a, b) => a.total_appointments - b.total_appointments,
        },
        {
            title: "Last Appointment",
            render: (_, record) => (
                <>
                    {record.latest_appointment ? (
                        <>
                            <div>{record.latest_appointment.date}</div>
                            <div className="text-muted small">
                                {record.latest_appointment.service} ({record.latest_appointment.meeting})
                            </div>
                        </>
                    ) : (
                        <span className="text-muted">No appointments</span>
                    )}
                </>
            ),
            sorter: (a, b) => {
                const dateA = a.latest_appointment?.date || '';
                const dateB = b.latest_appointment?.date || '';
                return dateA.localeCompare(dateB);
            },
        },
    ];

    const fetchData = async (page = 1, pageSize = 15) => {
        try {
            setLoading(true);
            const response = await Requests.getClients({
                page,
                per_page: pageSize
            });

            console.log('API Response:', response);

            if (response.data.success) {
                setData(response.data.data);
                setPagination({
                    current: response.data.pagination.current_page,
                    pageSize: response.data.pagination.per_page,
                    total: response.data.pagination.total,
                });
            }
        } catch (error) {
            console.error("Error fetching clients:", error);
            console.error("Error details:", error.response);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleTableChange = (pagination) => {
        fetchData(pagination.current, pagination.pageSize);
    };

    return (
        <>
            <Header />
            <SidebarNav />
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="page-title">Clients</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/admin">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Clients</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <Table
                                            columns={columns}
                                            dataSource={data}
                                            rowKey="id"
                                            pagination={{
                                                ...pagination,
                                                showSizeChanger: false,
                                                showTotal: (total, range) =>
                                                    `Showing ${range[0]} to ${range[1]} of ${total} clients`,
                                            }}
                                            loading={loading}
                                            onChange={handleTableChange}
                                            style={{ overflowX: "auto" }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Clients;